<template>
  <div class="home">
    <SiteHeader />
    <div id="smooth-wrapper">
    <div id="smooth-content">
      <div class="page">
        <div class="pinwrap">
          <div class="pin-left"><HeroSection /></div>
          <div class="pin-rail"><StatusRail /></div>
        </div>

        <NewsSection />

        <SolutionsSection />
        <AboutSection />
        <ReviewsSection />
        <SiteFooter />
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import SiteHeader from './site/SiteHeader.vue'
import HeroSection from './site/HeroSection.vue'
import StatusRail from './site/StatusRail.vue'
import NewsSection from './site/NewsSection.vue'
import SolutionsSection from './site/SolutionsSection.vue'
import AboutSection from './site/AboutSection.vue'
import ReviewsSection from './site/ReviewsSection.vue'
import SiteFooter from './site/SiteFooter.vue'
import { initSmoothScroll, killSmoothScroll } from '@/composables/useSmoothScroll'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default {
  name: 'HomePage',
  components: { SiteHeader, HeroSection, StatusRail, NewsSection, SolutionsSection, AboutSection, ReviewsSection, SiteFooter },
  mounted() {
    this.$nextTick(() => {
      initSmoothScroll()
      // ensure triggers measure correctly once fonts/layout settle
      requestAnimationFrame(() => ScrollTrigger.refresh())
    })
  },
  beforeUnmount() { killSmoothScroll() }
}
</script>

<style scoped>
.page {
  overflow-x: hidden;
  --rail-width: clamp(340px, 26vw, 440px);
}

.pinwrap {
  display: grid;
  grid-template-columns: 1fr var(--rail-width);
  align-items: start;
}
.pin-left { min-width: 0; }
.pin-rail {
  position: sticky; top: 0;
  height: 100vh; align-self: start;
  overflow: hidden;
}
.pin-rail :deep(.side) { height: 100%; }

@media (max-width: 900px) {
  .pinwrap { grid-template-columns: 1fr; }
  .pin-rail { position: static; height: auto; overflow: visible; }
}
</style>
